import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "gatsby-plugin-intl";

const Comp_spec_bullet = ({blackText, bulletSpec}) => {

    return (
          <ul className={`lg:text-lg text-left ${blackText ? "text-teal-800" : "text-blue-600"}`}>
            <li className="mt-2 md:mt-4 flex items-start">
              <div className="flex-shrink-0">
                <svg
                  className="h-6 w-6"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="4"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <p className="ml-3 leading-6 text-gray-800">
                <FormattedMessage id={bulletSpec} defaultMessage="desciption" />
              </p>
            </li>
          </ul>
    );
}

Comp_spec_bullet.propTypes = {
  bulletSpec: PropTypes.string,
  blackText: PropTypes.bool,
};

Comp_spec_bullet.defaultProps = {
  bulletSpec: null,
  blackText: true,
};


export default Comp_spec_bullet;